module.exports = __webpack_public_path__ + "static/media/toiletWrong.e0701f58.png";